import {
    DissectedError,
    DissectedErrorGroups,
    constructLogMessageFromResponseValidationErrors,
    exists,
} from '../../..'
import { logError, LogType } from '../../../Helpers'
import { ApiResponse } from '../../../types/Response'
import { DissectParserProps } from '../types/DissectParserTypes'
import { safeAwaitApiResponse } from './safeAwaitApiResponse'

export const parseApiResponseValidationErrors = async <TApiResponse extends ApiResponse = ApiResponse>({
    responseBody,
    responseStatusText,
    caller,
    responseStatus,
}: DissectParserProps<TApiResponse>): Promise<void> => {
    try {
        const awaitedApiResponse = (await safeAwaitApiResponse(responseBody)) as TApiResponse
        if (awaitedApiResponse.validationErrors && awaitedApiResponse.validationErrors.length > 0) {
            logError(constructLogMessageFromResponseValidationErrors(awaitedApiResponse))
            const statusCode = exists(awaitedApiResponse.errorCode) ? +awaitedApiResponse.errorCode : responseStatus
            throw new DissectedError('Validation errors found on apiResponse', {
                statusCode,
                statusMessage: responseStatusText,
                apiResponse: awaitedApiResponse,
                callerAction: caller,
                errorGroup: DissectedErrorGroups.IS_SUCCESS_FALSE,
                verboseMessage: 'validation errors present in api response',
            })
        }
    } catch (error) {
        if (error instanceof DissectedError) {
            throw error
        }
        logError('unexpected error', {
            logType: LogType.UNEXPECTED,
            caller: `${caller} - parseApiResponseValidationErrors`,
        })
    }
}
